export const ADMIN_ADDRESS = "7VYrhfQwS5QZSPcixmYacpiyJ8JMn9gsMBQtbSUPobqa";
export const PROJECT_VAULT_ADDRESS = "AyFptFmVf2vreKa8R9FF65E7WsKCqV5e9Bnkf6XB6mpM";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";